<template>
  <AppWithLoading :fetch="fetchIfEmpty" v-slot:default="{localLoading}">
    <template v-if="!localLoading && plan">
      <div class="dashboard-plan">
        <div class="dashboard-plan__title">
          <span>
            {{ $t('plan') }}:
            <a @click="showPlan()" class="dashboard-plan__name"> {{ plan.title }} </a>
          </span>
          <button @click="changePlan()" class="dashboard-plan__change">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 14.5017V17.0017H7.5L14.8733 9.62835L12.3733 7.12835L5 14.5017ZM16.8067 7.69502C17.0667 7.43502 17.0667 7.01502 16.8067 6.75502L15.2467 5.19502C14.9867 4.93502 14.5667 4.93502 14.3067 5.19502L13.0867 6.41502L15.5867 8.91502L16.8067 7.69502Z" fill="#0A82D9" />
            </svg>
            {{ $t('changePlan') }}
          </button>
        </div>
        <PlanQuotaItems />
      </div>
    </template>
  </AppWithLoading>
</template>

<script>
import useAccount from '@/compositions/accounting/useAccount';
import { paymentTabs, settingsTabs } from '@/enums';
import AppWithLoading from '@/components/AppWithLoading';
import { computed } from '@vue/composition-api';
import PlanQuotaItems from '@/components/Payment/Plans/PlanQuotaItems';

export default {
  name: 'QuotaLeft',
  components: {
    PlanQuotaItems,
    AppWithLoading,
  },
  setup(_, { root: { $router } }) {
    const {
      fetch, account,
    } = useAccount();

    function fetchIfEmpty() {
      if (!account.value) {
        return fetch();
      }

      return null;
    }

    const plan = computed(() => {
      if (account.value) {
        return account.value?.plan;
      }

      return null;
    });

    function changePlan() {
      $router.push({ name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLANS } });
    }

    function showPlan() {
      $router.push({ name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLAN } });
    }

    return {
      fetchIfEmpty,
      changePlan,
      showPlan,
      plan,
    };
  },
};
</script>

<style lang="scss" scoped>
.dashboard-plan {
  padding: 1.875rem;
  box-shadow: 0 2px 0.5rem rgba(0, 0, 0, 0.16);
  border-radius: 0.625rem;

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.125rem;
    line-height: 1.1;
    font-weight: 400;
    color: #212121;
    margin-bottom: 1.875rem;
  }
  &__name {
    color: #0A82D9;
  }
  &__change {
    font-size: 0.875rem;
    line-height: 1.57;
    font-weight: 400;
    color: #0A82D9;
    svg {
      display: inline-block;
      vertical-align: middle;
    }
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .dashboard-plan {
    margin-bottom: 1.25rem;
  }
}
</style>

<i18n lang="yml" locale="ru">
  plan: Ваш тариф
  changePlan: Изменить тариф
</i18n>
<i18n lang="yml" locale="en">
  plan: Your plan
  changePlan: Change plan
</i18n>
